import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogTrigger,
    } from '@/components/ui/alert-dialog';
    import DeleteButton from '@/components/DeleteButton.vue';
    import { useForm } from '@inertiajs/vue3';
    import { useQueryClient } from '@tanstack/vue-query';
    import { toast } from 'vue-sonner';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';

    interface Props {
        route: string;
        queryKey: Array<string | number>;
        buttonText?: string;
        header?: string;
        description?: string;
        cancelButtonText?: string;
        continueButtonText?: string;
        successMessage?: string;
        errorMessage?: string;
        method?: 'delete' | 'post';
        requestData?: Record<string, any>;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Delete',
  props: {
    route: {},
    queryKey: {},
    buttonText: {},
    header: { default: 'forms.delete_confirmation.header' },
    description: { default: 'forms.delete_confirmation.description' },
    cancelButtonText: { default: 'forms.delete_confirmation.cancel' },
    continueButtonText: { default: 'forms.delete_confirmation.continue' },
    successMessage: { default: 'forms.delete_confirmation.success' },
    errorMessage: { default: 'forms.delete_confirmation.error' },
    method: { default: 'delete' },
    requestData: { default: () => ({}) }
  },
  emits: ['deleted', 'error'],
  setup(__props: any, { emit: __emit }) {

    const queryClient = useQueryClient();

    const emit = __emit;

    const { t } = useI18n();

    const props = __props;

    const form = useForm(props.requestData);

    const deleteAction = () => {
        form[props.method](props.route, {
            preserveScroll: true,
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: props.queryKey });
                toast.success(t(props.successMessage));
                emit('deleted');
            },
            onError: (error) => {
                toast.error(error?.error || t(props.errorMessage));
                emit('error', error);
            },
        });
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(DeleteButton, { "button-text": _ctx.buttonText }, null, 8, ["button-text"])
        ]),
        _: 1
      }),
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.header)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "description", {}, () => [
                    _createTextVNode(_toDisplayString(_ctx.$t(_ctx.description)), 1)
                  ])
                ]),
                _: 3
              })
            ]),
            _: 3
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.cancelButtonText)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), { onClick: deleteAction }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.continueButtonText)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})